module.exports = __webpack_public_path__ + "static/media/najelaa_shihab.bdadd463.jpg";